import { z } from 'zod';

/** Rentang laporan terpanjang; lebih dari ini sebaiknya diekspor per periode. */
export const REPORT_MAX_DAYS = 366;

const dateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Format tanggal YYYY-MM-DD');

function daysBetween(from: string, to: string): number {
  return (Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000;
}

/** Tanggal kalender WIB, keduanya inklusif. */
export const reportRangeSchema = z
  .object({ from: dateOnly, to: dateOnly })
  .refine((v) => daysBetween(v.from, v.to) >= 0, {
    message: 'Tanggal akhir harus sama atau setelah tanggal awal',
    path: ['to'],
  })
  .refine((v) => daysBetween(v.from, v.to) < REPORT_MAX_DAYS, {
    message: `Rentang maksimal ${REPORT_MAX_DAYS} hari`,
    path: ['to'],
  });

export const REPORT_GROUPS = ['day', 'week', 'month'] as const;
export type ReportGroup = (typeof REPORT_GROUPS)[number];

export const reportSummaryQuerySchema = z
  .object({ from: dateOnly, to: dateOnly, group: z.enum(REPORT_GROUPS).default('day') })
  .and(reportRangeSchema);

export type ReportRange = z.infer<typeof reportRangeSchema>;
export type ReportSummaryQuery = z.infer<typeof reportSummaryQuerySchema>;
